module.exports = __webpack_public_path__ + "static/Kinto-82e968c1d4c273b71c1151e006140bed.png";